import React from "react";
import { v4 } from "uuid";
import ListCards from "src/components/ListCards";
import { ICardOKRs } from "./interface";
import CardOKR from "./card";

const CardOKRs: React.FC<ICardOKRs> = ({
	data,
	options,
	onViewHierarchy,
	openKRs
}) => (
	<ListCards 
			 data={data}
			 mapper={(row) => <CardOKR key={v4()} data={row} onViewHierarchy={onViewHierarchy} openKRs={openKRs} options={options} />}
	/>
);

export default CardOKRs;
